import { render } from "./Propiedades.vue?vue&type=template&id=4c6e125a&scoped=true"
import script from "./Propiedades.vue?vue&type=script&lang=js"
export * from "./Propiedades.vue?vue&type=script&lang=js"

import "./Propiedades.vue?vue&type=style&index=0&id=4c6e125a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6e125a"]])

export default __exports__